import React from "react";
import styled from "styled-components";
import TextAtm from "../../../atoms/TextAtm";
var Title = styled(TextAtm).withConfig({
  componentId: "sc-kum13d-0"
})(["font-feature-settings:\"clig\" off,\"liga\" off;white-space:pre-line;"]);
var ModalTitle = function ModalTitle(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(Title, {
    typography: "great",
    hasInheritedColor: true
  }, children);
};
export default ModalTitle;